'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createVideoSet = exports.createAudioSet = exports.createImageSet = exports.createAudio = exports.createVideo = exports.createImage = exports.createArticle = exports.createURL = exports.editContent = exports.removeContent = exports.getContent = exports.createContent = exports.listContent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _camelcase = require('camelcase');

var _camelcase2 = _interopRequireDefault(_camelcase);

var _actions = require('../utils/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var listContent = exports.listContent = function listContent(query) {
  return {
    args: { query: query },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('listContent'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return client.get(_actions.apiPrefix + '/content/' + userId, {
        q: query,
        resType: 'json'
      });
    }
  };
};

var createContent = exports.createContent = function createContent(properties) {
  return {
    args: { properties: properties },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('createContent'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return client.post(_actions.apiPrefix + '/content/' + userId, {
        resType: 'json',
        body: properties
      });
    }
  };
};

var getContent = exports.getContent = function getContent(contentId) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var password = opts.password;

  return {
    args: { contentId: contentId, password: password },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('getContent'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return password ? client.post(_actions.apiPrefix + '/content/' + userId + '/' + contentId, {
        body: { password: password },
        resType: 'json'
      }) : client.get(_actions.apiPrefix + '/content/' + userId + '/' + contentId, {
        resType: 'json'
      });
    }
  };
};

var removeContent = exports.removeContent = function removeContent(contentId) {
  return {
    args: { contentId: contentId },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('removeContent'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return client.del(_actions.apiPrefix + '/content/' + userId + '/' + contentId);
    }
  };
};

function resolveEditContent(properties) {
  Object.keys(properties).forEach(function (key) {
    var replaceKey = void 0;
    if (key.endsWith('Add')) {
      replaceKey = '+' + (0, _camelcase2.default)(key.slice(0, -3));
    } else if (key.endsWith('Del')) {
      replaceKey = '-' + (0, _camelcase2.default)(key.slice(0, -3));
    }
    if (!replaceKey) return;
    properties[replaceKey] = properties[key];
    delete properties[key];
  });
}

var editContent = exports.editContent = function editContent(contentId, properties) {
  var body = _extends({}, properties);
  resolveEditContent(body);
  return {
    args: { contentId: contentId, properties: body },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('editContent'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return client.patch(_actions.apiPrefix + '/content/' + userId + '/' + contentId, {
        body: body
      });
    }
  };
};

var createURL = exports.createURL = function createURL(properties) {
  return {
    args: { properties: properties },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('createURL'),
    minselfAPICall: function minselfAPICall(client) {
      return client.post(_actions.apiPrefix + '/content/create/url', {
        body: properties
      });
    }
  };
};

var createArticle = exports.createArticle = function createArticle(properties) {
  return {
    args: { properties: properties },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('createArticle'),
    minselfAPICall: function minselfAPICall(client) {
      return client.post(_actions.apiPrefix + '/content/create/article', {
        body: properties
      });
    }
  };
};

function toStringIfExist(obj) {
  return typeof obj !== 'undefined' || obj !== null ? obj.toString() : undefined;
}

var createImage = function createImage(_ref) {
  var toSet = _ref.toSet,
      inList = _ref.inList,
      body = _ref.body,
      properties = _objectWithoutProperties(_ref, ['toSet', 'inList', 'body']);

  return {
    args: _extends({ toSet: toSet, inList: inList, body: body && '[File]' }, properties),
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('createImage'),
    minselfAPICall: function minselfAPICall(client) {
      return client.post(_actions.apiPrefix + '/content/create/image', {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        body: _extends({
          toSet: toStringIfExist(toSet),
          inList: toStringIfExist(toSet),
          body: body
        }, properties)
      });
    }
  };
};

exports.createImage = createImage;
var createVideo = function createVideo(_ref2) {
  var toSet = _ref2.toSet,
      inList = _ref2.inList,
      body = _ref2.body,
      properties = _objectWithoutProperties(_ref2, ['toSet', 'inList', 'body']);

  return {
    args: _extends({ toSet: toSet, inList: inList, body: body && '[File]' }, properties),
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('createVideo'),
    minselfAPICall: function minselfAPICall(client) {
      return client.post(_actions.apiPrefix + '/content/create/video', {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        body: _extends({
          toSet: toStringIfExist(toSet),
          inList: toStringIfExist(toSet),
          body: body
        }, properties)
      });
    }
  };
};

exports.createVideo = createVideo;
var createAudio = function createAudio(_ref3) {
  var toSet = _ref3.toSet,
      inList = _ref3.inList,
      body = _ref3.body,
      properties = _objectWithoutProperties(_ref3, ['toSet', 'inList', 'body']);

  return {
    args: { toSet: toSet, inList: inList, body: body && '[File]' },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('createAudio'),
    minselfAPICall: function minselfAPICall(client) {
      return client.post(_actions.apiPrefix + '/content/create/audio', {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        body: _extends({
          toSet: toStringIfExist(toSet),
          inList: toStringIfExist(toSet),
          body: body
        }, properties)
      });
    }
  };
};

exports.createAudio = createAudio;
function createMediaSet(actionType, type, list) {
  return {
    args: { list: list },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)(actionType),
    minselfAPICall: function minselfAPICall(client) {
      return client.post(_actions.apiPrefix + '/content/create/' + type, {
        body: { include: list }
      });
    }
  };
}

var createImageSet = exports.createImageSet = function createImageSet(list) {
  return createMediaSet('createImageSet', 'imageSet', list);
};
var createAudioSet = exports.createAudioSet = function createAudioSet(list) {
  return createMediaSet('createAudioSet', 'audioSet', list);
};
var createVideoSet = exports.createVideoSet = function createVideoSet(list) {
  return createMediaSet('createVideoSet', 'videoSet', list);
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/actions/content.js
// module id = 506
// module chunks = 1